import React from "react";
//local
import {Tag} from "components/Tag";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {IconEdit} from "components/icons";
import {color} from "constants/color.consts";

export const EditorTemplateRow = ({template, onSelect, onEdit}) => (
  <div
    className={`modal-editor-templates__table-row${!!onSelect ? " selectable" : ""}`}
    onClick={() => !!onSelect && onSelect(template.id)}
  >
    <div className="modal-editor-templates__table-row-name">{template.name}</div>
    {!onSelect && (
      <Tag
        text={template.type}
        color={color.discreteText}
        uppercase
        bold
        small
        addClass="fz-10"
        needTranslation
      />
    )}

    {/*<Tag
      text={template.level}
      color={color.midGray}
      uppercase
      bold
      small
      addClass="fz-10"
      needTranslation
    />*/}
    {!onSelect && (
      <ButtonTransparent
        addClass="pa-0 mla"
        small
        noBorder
        icon={<IconEdit addClass="mr-0" />}
        onClick={(e) => {
          e.stopPropagation();
          onEdit(template.id);
        }}
      />
    )}
  </div>
);
